import { DownOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Collapse } from 'antd';

import type {
  AutoInventorySteps,
  AutoInventoryStepsModern,
} from 'app/typings/autoInventory';
import { amplitudeTrack } from 'app/utils/track/amplitude';

import './HowDoesItWork.scss';

const { Panel } = Collapse;

export type Item = {
  title: string;
  description: string;
  emoji: string;
};

export type TrackFrom = 'pricing-rule' | 'auto-inventory';

type HowDoesItWorkProps = {
  items: Item[];
  trackFrom: TrackFrom;
  stepFrom?: AutoInventorySteps | AutoInventoryStepsModern;
};

export const HowDoesItWork = ({
  items,
  trackFrom,
  stepFrom,
}: HowDoesItWorkProps) => {
  return (
    <div className="howDoesItWork">
      <Collapse
        className="howDoesItWork-collapse"
        bordered={false}
        expandIconPosition="end"
        expandIcon={({ isActive }) => (
          <DownOutlined rotate={isActive ? 180 : 0} />
        )}
        onChange={(e) =>
          amplitudeTrack('How does it work', {
            from: trackFrom,
            step: stepFrom,
          })
        }
      >
        <Panel
          key="Pricing Rule Description"
          header={
            <div className="explanation-header">
              <QuestionCircleOutlined /> <h3>How does it work?</h3>
            </div>
          }
          className="explanation-panel"
        >
          <ul className="description-list">
            {items.map((item, idx) => {
              return (
                <li
                  key={`how-does-it-work-li-${idx}`}
                  className="description-list__item"
                >
                  <span className="description-list__item--bold">
                    {`${item.emoji} ${item.title} : `}
                  </span>
                  {item.description}
                </li>
              );
            })}
          </ul>
        </Panel>
      </Collapse>
    </div>
  );
};
